function setCSSVars() {
  const header = document.querySelector('[data-site-header]');
  const container = document.querySelector('.page-width');
  const cartFooter = document.querySelector('.drawer__footer');
  const announcement = document.querySelector('.announcement-bar');
  const hero = document.querySelector('.main-hero');
  const ymm = document.querySelector('.easysearch-main-widget');

  const headerHeight = header?.offsetHeight || 150;
  const windowHeight = window.innerHeight;
  const halfPageOffset = container?.offsetLeft || 0;
  const cartFooterHeight = cartFooter?.offsetHeight || 0;
  const announcementHeight = announcement?.offsetHeight || 40;
  const heroHeight = hero?.offsetHeight || 0;
  const ymmHeight = ymm?.offsetHeight || 0;

  document.documentElement.style.setProperty(
    '--window-height',
    `${windowHeight}px`
  );
  document.documentElement.style.setProperty(
    '--header-height',
    `${headerHeight}px`
  );
  document.documentElement.style.setProperty(
    '--half-page-offset',
    `${halfPageOffset}px`
  );
  document.documentElement.style.setProperty(
    '--cart-footer-height',
    `${cartFooterHeight}px`
  );
  document.documentElement.style.setProperty(
    '--announcement-height',
    `${announcementHeight}px`
  );

  document.documentElement.style.setProperty(
    '--ymm-height',
    `${ymmHeight}px`
  );

    document.documentElement.style.setProperty(
    '--hero-height',
    `${heroHeight}px`
  );
}

// Initial set
setCSSVars();

// Responsive updates
window.addEventListener('resize', debounce(setCSSVars, 100));
window.addEventListener(
  'scroll',
  debounce(() => {
    const header = document.querySelector('[data-site-header]');
    const headerHeight = header?.offsetHeight || 150;
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
  }, 50)
);

const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  function fixHeader() {
    const scroll = window.scrollY;

    if (scroll > 0) {
      siteHeader.classList.add('scrolling');
    } else {
      siteHeader.classList.remove('scrolling');
    }
  }

  window.addEventListener('scroll', debounce(fixHeader, 50));
  window.addEventListener('resize', debounce(fixHeader, 50));
  window.addEventListener('load', fixHeader);
}


/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  if (event.target.dataset.toggleTarget) {
    console.log('toggle');
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    console.log('tab');
    tabToggle(event);
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  console.log('slider toggle');
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');
  const target = event.target.dataset.toggleTarget;
  console.log(target, 'TARGET');
  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );

  console.log(toggleContainer);

  toggleContainer.forEach((group) => {
    if (!group.classList.contains('active')) {
      group.classList.add('active');
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';
      setTimeout(function () {
        group.style.height = height;
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          console.log('transition end');
          group.style.height = 'auto';
        },
        {
          once: true,
        }
      );
    } else {
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      console.log(height, 'height');
      group.style.height = height;
      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        console.log('remove active', group);
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          console.log('transition end');
          group.style.height = '0px';
        },
        {
          once: true,
        }
      );
    }
  });
  // FOR RESETTING ALL ITEMS
  toggles.forEach((toggle) => {
    if (
      (toggle.dataset.toggleTarget == target) &
      toggle.classList.contains('active')
    ) {
      toggle.classList.remove('active');
    } else {
      toggle.classList.add('active');
    }

    if (toggle.dataset.toggleTarget != target) {
      toggle.classList.remove('active');
    }
  });

  targets.forEach((toggle) => {
    if (toggle.dataset.toggleContent != target) {
      toggle.classList.remove('active');
    }
  });
}

/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  tabGroups.forEach((group) => {
    group.classList.remove('active');
  });
  event.target.classList.add('active');
  document
    .querySelectorAll(
      `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
    )
    .forEach((group) => {
      group.classList.add('active');
    });
}

// MODAL TOGGLING
document.querySelectorAll('[data-modal-target]').forEach((btnOpen) => {
  btnOpen.onclick = function (event) {
    const target = btnOpen.dataset.modalTarget;
    const modalContent = document.querySelector(
      `[data-modal-content="${target}"]`
    );
    const closeModal = modalContent.querySelector('[data-close]');
    const modalSlider = modalContent.querySelector('.bd-slider');

    event.preventDefault();
    console.log('open modal');
    modalContent.classList.add('active');

    document.querySelector('body').classList.add('overflow-hidden');
    closeModal.onclick = function () {
      //  console.log('close modal');
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    };
    window.onclick = function (event) {
      // console.log(event);
      if (event.target == modalContent) {
        // console.log('close modal');

        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    };
    window.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') {
        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });

    if (modalSlider) {
      const slider = new slick(modalSlider);
      console.log('resize slider');
      slider.resize();
    }
  };
});

/************ Smooth Scroll  ****************/
// Rewritten 2 Sep 2026. The old version cancelled every in-page "#" link and
// then called headerHeight(), which does not exist, so it threw and nothing
// scrolled (the review stars -> #judgeme_product_reviews link did nothing).
// Now the page glides to the target in one motion, re-aiming every frame at
// the target's live position (so images loading in above it cannot make it
// land short or long) and leaving room for whatever is pinned to the top.
(function () {
  var GAP = 20;
  var DURATION = 650;

  // Height of fixed / sticky things currently pinned across the top of the screen.
  function pinnedTop() {
    var h = 0, vw = window.innerWidth, vh = window.innerHeight;
    var sel = 'header, [data-site-header], .announcement-bar, .easysearch-main-widget, ' +
      '.shopify-section-group-bd-header-group, .shopify-section-group-bd-header-group > *, ' +
      '[class*="sticky"], [class*="fixed"]';
    document.querySelectorAll(sel).forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.pointerEvents === 'none') return;
      var r = el.getBoundingClientRect();
      if (r.top > 1 || r.width < vw * 0.5 || r.height > vh * 0.6) return;
      if (r.bottom > h) h = r.bottom;
    });
    return h;
  }

  var running = null;
  function cancelRun() { if (running) { running.cancelled = true; running = null; } }
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, cancelRun, { passive: true }); });

  function glideTo(target) {
    cancelRun();
    var run = { cancelled: false };
    running = run;
    var startY = window.scrollY;
    var t0 = null;
    var max = function () { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); };
    function dest() { return Math.min(max(), Math.max(0, target.getBoundingClientRect().top + window.scrollY - pinnedTop() - GAP)); }
    function ease(p) { return p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; }
    function frame(now) {
      if (run.cancelled) return;
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / DURATION);
      var d = dest();
      window.scrollTo(0, startY + (d - startY) * ease(p));
      if (p < 1) { requestAnimationFrame(frame); }
      else { window.scrollTo(0, dest()); running = null; }
    }
    requestAnimationFrame(frame);
    // Frames do not run in a background tab: just land there instead.
    setTimeout(function () { if (!run.cancelled && running === run && t0 === null) { run.cancelled = true; running = null; window.scrollTo(0, dest()); } }, 300);
  }

  document.addEventListener('click', function (e) {
    var anchor = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!anchor || anchor.classList.contains('no-scroll')) return;
    if (anchor.getAttribute('href') === '#') return;
    if (anchor.dataset.tabTarget || anchor.dataset.toggleTarget || anchor.dataset.modalTarget) return;
    if (anchor.hostname !== location.hostname) return;
    if (anchor.pathname.replace(/^\//, '') !== location.pathname.replace(/^\//, '')) return;
    var id = '';
    try { id = decodeURIComponent((anchor.hash || '').slice(1)); } catch (err) { id = (anchor.hash || '').slice(1); }
    if (!id) return;
    var target = document.getElementById(id) || document.querySelector('[name="' + id.replace(/"/g, '') + '"]');
    if (!target) return;
    e.preventDefault();
    glideTo(target);
    try { history.replaceState(null, '', '#' + id); } catch (err) {}
  });
})();

// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}

/** VARIANT SELECTS DISABLE ADD TO **/

document.querySelectorAll('variant-selects').forEach((dropdown) => {
  const selects = dropdown.querySelectorAll('select');
  const formId = selects[0].getAttribute('form');
  const values = Array.from(selects).map((el) => el.value);
  console.log(formId);
  console.log(values);

  function checkAvailability(arr, val) {
    return arr.some((arrVal) => val === arrVal);
  }
  if (checkAvailability(values, 'no-option')) {
    document
      .querySelector(`#${formId}`)
      .parentElement.classList.add('disabled');
  } else {
    document
      .querySelector(`#${formId}`)
      .parentElement.classList.remove('disabled');
  }
  selects.forEach((input) => {
    input.addEventListener('change', (e) => {
      const values = Array.from(selects).map((el) => el.value);
      console.log('select change', e);
      if (checkAvailability(values, 'no-option')) {
        document
          .querySelector(`#${formId}`)
          .parentElement.classList.add('disabled');
      } else {
        document
          .querySelector(`#${formId}`)
          .parentElement.classList.remove('disabled');
        console.log(input, 'disable no value');
        input.querySelector('[data-no-option]').setAttribute('disabled', true);
      }
    });
  });
});